module.exports = __webpack_public_path__ + "static/media/logo.7835673d.png";